import VSwitch from './VSwitch.vue';

export { VSwitch };
export default VSwitch;
